<template>
  <div class="style3">
    <div class="count-down" v-if="aucTimeStyle == 0 || aucTimeStyle == 1">
      <p class="desc3" v-if="aucTimeStyle == 0">距离开拍</p>
      <p class="desc3" v-if="aucTimeStyle == 1">距离结拍</p>
      <p class="t5" v-if="day != '00'">{{ day }}</p>
      <p class="t6" v-if="day != '00'">天</p>
      <p class="t5">{{ hours }}</p>
      <p class="t6">时</p>
      <p class="t5">{{ minutes }}</p>
      <p class="t6">分</p>
      <p class="t5">{{ seconds }}</p>
      <p class="t6">秒</p>
    </div>
    <div v-else-if="aucTimeStyle == 2" class="count-down">
      <p class="desc3">已结束</p>
    </div>
  </div>
</template>

<script>
import { formatDateTimeMu } from '@/utils/index';
export default {
  props: {
    time: {
      type: String,
    },
    startTime: {
      type: Number,
      default: 0,
    },
    endTime: {
      type: Number,
      default: 0,
    },
    liveEndTime: {
      type: Number,
      default: 0,
    },
    liveStartTime: {
      type: Number,
      default: 0,
    },
    sync: {
      type: Boolean,
      default: false,
    },
    aucType: {
      type: Number,
    },
    aucStatus: {
      type: Number,
      default: -1,
    },
    showStatus: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      day: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
      millisecond: '00',
      aucTimeStyle: 3, // 0 未开拍 1 拍卖中 2 拍卖已结束 3 没有传时
    };
  },
  created() {
    this.updateTime();
  },
  watch: {
    startTime() {
      this.updateTime();
    },
    endTime() {
      this.updateTime();
    },
    liveEndTime() {
      this.updateTime();
    },
    liveStartTime() {
      this.updateTime();
    },
    showStatus() {
      this.updateTime();
    },
  },
  methods: {
    formatDateTimeMu,
    updateTime(e) {
      if (this.sync) {
        let aucTimeStyle = 3;
        if (this.liveStartTime == 0 && this.liveEndTime == 0) {
          aucTimeStyle = 0;
        } else if (this.liveStartTime > 0 && this.liveEndTime == 0) {
          aucTimeStyle = 1;
        } else if (this.liveEndTime > 0) {
          aucTimeStyle = 2;
        }
        this.aucTimeStyle = aucTimeStyle;
      } else {
        if (this.startTime && this.endTime) {
          if (this.timer) {
            clearInterval(this.timer);
          }
          let currentTime = new Date().valueOf();
          let aucTimeStyle = 3;
          // 未开拍
          if (currentTime < this.startTime) {
            this.aucTimeStyle = 0;
          } // 拍卖中
          else if (currentTime >= this.startTime && currentTime < this.endTime) {
            this.aucTimeStyle = 1;
          } // 拍卖已结束
          else if (currentTime >= this.endTime) {
            this.aucTimeStyle = 2;
          }
          this.timer = setInterval(() => {
            this.setTime();
          }, 500);
        }
      }
    },
    initDate(day, hours, minutes, seconds) {
      this.day = day;
      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;
    },
    setTime() {
      let date1 = Date.now(); //开始时间
      let time = this.startTime;
      if (this.aucTimeStyle == 0) {
        time = this.startTime;
        if (time < date1) {
          // 更改状态为拍卖中
          time = this.endTime;
          this.aucTimeStyle = 1;
          this.$emit('timeEndAction');
        }
      } else if (this.aucTimeStyle == 1) {
        time = this.endTime;
        if (time < date1) {
          // 更改状态为已结束
          this.aucTimeStyle = 2;
          this.initDate('00', '00', '00', '00');
          clearInterval(this.timer);
          this.$emit('timeEndAction');
          return;
        }
      } else {
        clearInterval(this.timer);
        console.log('timeCountDown error');
        return;
      }

      let usedTime = time - date1; //两个时间戳相差的毫秒数
      //计算出天数
      let dayTime = Math.floor(usedTime / (24 * 3600 * 1000));
      //计算出小时数
      let leave1 = usedTime % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      let leave3 = leave2 % (60 * 1000); //
      let seconds = Math.floor(leave3 / 1000);
      this.initDate(
        this.leftPad(dayTime),
        this.leftPad(hours),
        this.leftPad(minutes),
        this.leftPad(seconds),
      );
    },
    leftPad(n) {
      return n < 10 ? '0' + n : n;
    },
  },
  detached() {
    console.log('timeCountDown component detached');
    clearInterval(this.timer);
  },
};
</script>
<style lang="less" scoped>
.style3 {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
  .count-down {
    display: inline-flex;
    background: #f6f6f6;
    padding: 1px 2px;
    .desc3 {
      margin-right: 3px;
    }
  }
}
</style>
